/* eslint-disable */

import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { connect } from 'react-redux'
import { withStyles } from 'material-ui/styles';
import { enums } from "../enums";
import moment from "moment";
import Button from "material-ui/Button";
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import ListItemText from '@material-ui/core/ListItemText';
import { Row, Col } from 'react-flexbox-grid';
import Table, {
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  TableSortLabel,
} from 'material-ui/Table';
import green from 'material-ui/colors/green';
import { CircularProgress } from 'material-ui/Progress';

import Toolbar from 'material-ui/Toolbar';
import Typography from 'material-ui/Typography';
import Paper from 'material-ui/Paper';
import Tooltip from 'material-ui/Tooltip';

import { withRouter } from 'react-router';
import { lighten } from 'material-ui/styles/colorManipulator';

import Grid from 'material-ui/Grid';

import {
  startLoadingDashboard,
  dashboardStartNew,
  dashboardStart,
  stopLoadingDashboard,
  sortAssetsConsuming,
  changePage,
  changeRowsPerPage,
  getUsername,
  toggleCo2DetailsDialog_Dashboard,
  getUserTotalYearToDateAvoidedCO2,
  getCountriesRelatedToUserConsumingSites,
  setCountriesMenuState,
  globalViewButtonClicked,
  countryViewButtonClicked
} from '../actions';

import { translate } from "react-i18next";
import { DoughnutCard } from './ChartCards/DoughnutCard';
import { AvoidedCO2Dialog } from './EquivalentToCards/AvoidedCO2/AvoidedCO2Dialog';
import { AvoidedCO2Card } from './EquivalentToCards/AvoidedCO2/AvoidedCO2Card';
import { ConvertedAvoidedCO2Card } from './EquivalentToCards/ConvertedAvoidedCO2/ConvertedAvoidedCO2Card';
import { GreenElectricityCard as GreenElectricityCardNew } from './EquivalentToCards/GreenElectricity/GreenElectricityCard';
import { AverageDistanceCard } from './EquivalentToCards/AverageDistance/AverageDistanceCard';

class DashboardHead extends React.Component {
  createSortHandler = property => event => {
    this.props.onRequestSort(event, property);
  };

  render() {
    const { order, orderBy, t } = this.props;

    const columnData = [
      { id: 'consumingAsset', numeric: false, disablePadding: false, label: t("Asset") },
      { id: 'country', numeric: false, disablePadding: false, label: t("Country") }
    ];

    return (
      <TableHead>
        <TableRow>
          {columnData.map(column => {
            return (
              <TableCell
                key={column.id}
                numeric={column.numeric}
                padding={column.disablePadding ? 'none' : 'default'}
                sortDirection={orderBy === column.id ? order : false}
              >
                <Tooltip
                  title={t("Sort")}
                  placement={column.numeric ? 'bottom-end' : 'bottom-start'}
                  enterDelay={300}
                >
                  <TableSortLabel
                    active={orderBy === column.id}
                    direction={order}
                    onClick={this.createSortHandler(column.id)}
                  >
                    {t(column.label)}
                  </TableSortLabel>
                </Tooltip>
              </TableCell>
            );
          }, this)}
        </TableRow>
      </TableHead>
    );
  }
}

DashboardHead.propTypes = {
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.string.isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired
};

const toolbarStyles = theme => ({
  root: {
    paddingRight: theme.spacing.unit,
  },
  highlight:
    theme.palette.type === 'light'
      ? {
          color: theme.palette.secondary.main,
          backgroundColor: lighten(theme.palette.secondary.light, 0.85),
        }
      : {
          color: theme.palette.text.primary,
          backgroundColor: theme.palette.secondary.dark,
        },
  spacer: {
    flex: '1 1 100%',
  },
  actions: {
    color: theme.palette.text.secondary,
  },
  title: {
    flex: '0 0 auto',
  },
});

let DashboardToolbar = props => {
  const { numSelected, classes, loading, t, i18n } = props;

  return (
    <Toolbar
      className={classNames(classes.root, {
        [classes.highlight]: numSelected > 0,
      })}
    >
      <div className={classes.title}>
        {numSelected > 0 ? (
          <Typography color="inherit" variant="subheading">
            {numSelected} selected
          </Typography>
        ) : (
          <Typography variant="title">
            {t("Consuming assets")}
            {loading &&
              <CircularProgress size={24} className={classes.buttonProgress} />
            }
          </Typography>
        )}
      </div>
    </Toolbar>
  );
};

DashboardToolbar.propTypes = {
  classes: PropTypes.object.isRequired,
  numSelected: PropTypes.number.isRequired,
};

DashboardToolbar = withStyles(toolbarStyles)(DashboardToolbar);

const styles = theme => ({
  root: {
    width: '100%',
    marginTop: theme.spacing.unit * 3,
  },
  table: {
    minWidth: 1020,
  },
  tableWrapper: {
    overflowX: 'auto',
  },
  buttonProgress: {
    color: green[500],
    position: 'relative',
    bottom: -30,
    left: 100,
    marginTop: -12,
    marginLeft: -12,
  },
});

const StyledMenu = withStyles({
  paper: {
    border: '1px solid #d3d4d5',
  },
})((props) => (
  <Menu
    elevation={0}
    getContentAnchorEl={null}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'center',
    }}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'center',
    }}
    {...props}
  />
));

const StyledMenuItem = withStyles((theme) => ({
  root: {
    '&:focus': {
      backgroundColor: theme.palette.primary.main,
      '& .MuiListItemIcon-root, & .MuiListItemText-primary': {
        color: theme.palette.common.white,
      },
    }
  },
  selected: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.common.white,
  }
}))(MenuItem);

class Dashboard extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      order: 'asc',
      orderBy: 'id',
      selected: [],
      data: [],
      page: 0,
      rowsPerPage: 5,
      anchorEl: null,
      selectedIndex: null
    };
  }

  componentDidMount = async () => {
    const authenticationCheck = await localStorage.getItem('isAuthenticated');
    const lastDashboardLoad = this.props.lastDashboardLoad;

    const now = moment();
    const then = moment.unix(lastDashboardLoad);
    const delta = now.diff(then, 'milliseconds');

    if(authenticationCheck) {
      this.props.globalViewButtonClicked();
      if(delta && delta > 60*60*1000) {//Reload if last dashboard data load > 1hour
        await this.props.getCountriesRelatedToUserConsumingSites()
        this.props.startLoadingDashboard();
        await this.props.dashboardStartNew();
        this.props.stopLoadingDashboard();
      } else {
        this.props.stopLoadingDashboard();
      }
    } else {
      this.props.history.push('/')
    }
  };

  handleCountryChanged = async (event, index) => {
    this.setState({selectedIndex: index});
    let countryId = this.props.uniqueCountriesArray[index]._id;
    this.props.startLoadingDashboard();
    await this.props.dashboardStartNew(countryId.toString());
    this.props.stopLoadingDashboard();
  }

  handleGlobalViewButtonClicked = async (event) => {
    this.props.globalViewButtonClicked();
    this.setState({selectedIndex: null});
    this.props.startLoadingDashboard();
    await this.props.dashboardStartNew();
    this.props.stopLoadingDashboard();
  }

  handleRequestSort = (event, property) => {
    const orderBy = property;
    let order = 'desc';

    if (this.props.orderBy === property && this.props.order === 'desc') {
      order = 'asc';
    }

    const assets =
      order === 'desc'
        ? this.props.assets.sort((a, b) => (b[orderBy] < a[orderBy] ? -1 : 1))
        : this.props.assets.sort((a, b) => (a[orderBy] < b[orderBy] ? -1 : 1));

    this.props.sortAssetsConsuming( assets, order, orderBy );
  };

  
  handleChangePage = (event, page) => {
    this.props.changePage(page);
  };

  
  handleClick = (event, id) => {
    this.props.history.push('/assets/cons/read/'+id);
  };

  //Below are functions provided initially by material ui
  //Visit https://material-ui-next.com/demos/tables/#sorting-amp-selecting for details

  handleSelectAllClick = (event, checked) => {
    if (checked) {
      this.setState({ selected: this.state.data.map(n => n.id) });//Do this redux way
      return;
    }
    this.setState({ selected: [] });//Do this redux way
  };

  renderGlobalViewButton() {
    const {
      globalViewButtonPressed,
      t
    } = this.props;

    return (
      <Button
        color="primary"
        variant={globalViewButtonPressed ? "raised" : "flat"}
        onClick={async () => {
          await this.handleGlobalViewButtonClicked()
        }}
      >
        {t("Global view")}
      </Button>
    );
  }

  handleToggleCountriesMenu = (event) => {
    this.props.countryViewButtonClicked();
    let prevOpen = this.props.countriesMenuOpen;
    this.setCountriesMenuState(!prevOpen);
    this.setAnchorEl(event.currentTarget);
  };

   handleClose = event => {
    this.setCountriesMenuState(false);
    this.setAnchorEl(null);
  };

  setCountriesMenuState = (value) => {
    this.props.setCountriesMenuState(value)
  }

  setAnchorEl = (value) => {
    this.setState({anchorEl: value})
  }

  renderChooseCountryMenu() {
    const { countriesMenuOpen, uniqueCountriesArray, countryViewButtonPressed , t} = this.props;
    let anchorEl = this.state.anchorEl;
    let selectedIndex = this.state.selectedIndex;
    return (
      <Grid container direction="column" style={{ minWidth: "100%" }}>
        <Button
          color="primary"
          variant={countryViewButtonPressed ? "raised" : "flat"}
          size="small"
          aria-haspopup="menu"
          onClick={(event) => this.handleToggleCountriesMenu(event)}
        >
          {t("Country view")}
        </Button>
        {countriesMenuOpen && (
          <ClickAwayListener onClickAway={() => this.handleClose()}>
            <StyledMenu
            id="customized-menu"
            anchorEl={anchorEl}
            keepMounted
            open={countriesMenuOpen}
            onClose={() => this.handleClose()}
          >
            {uniqueCountriesArray.map((option, index) => (
              <StyledMenuItem
                onClick={(event) => {this.handleClose(); this.handleCountryChanged(event, index)}}
                selected={index === selectedIndex}
              >
                <ListItemText primary={option.name} />
              </StyledMenuItem>
            ))}
          </StyledMenu>
        </ClickAwayListener>
        )}
      </Grid>
    );
  }

  handleClickSelect = (event, id) => {
    const { selected } = this.state;
    const selectedIndex = selected.indexOf(id);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1),
      );
    }

    this.setState({ selected: newSelected });
  };


  isSelected = id => this.state.selected.indexOf(id) !== -1;
 
  renderCountryNavigation() {
    return (
      <Grid item xs={12} sm={12} style={{ marginLeft: 10, float: "left" }}>
        <Row>
          <Col>
            {this.renderGlobalViewButton()}
          </Col>
          <Col> 
            {this.renderChooseCountryMenu()}
          </Col>
        </Row>
      </Grid>
    );
  }

  render() {
    const { classes } = this.props;
    const {
      order,
      orderBy,
      selected,
      page,
      loading,
      t, i18n,
      frontEndDataForUser,
      activeUserConsumingAssets,
      matchingFrequency,
      countryNavigationEnabled,
      user
    } = this.props;

    if(
      !activeUserConsumingAssets  ||
      activeUserConsumingAssets.length === 0 ||
      loading
    ) {
      return (
        <div className={classes.root}>
          <Grid container spacing={24}>
            <Grid item xs={12}  style={{ display: 'flex', justifyContent: 'center', alignItems: 'flex-end' }}>
              <CircularProgress size={24} />
            </Grid>
          </Grid>
        </div>
      )
    }
    const rowsPerPage = this.state.rowsPerPage;
    const emptyRows = rowsPerPage - Math.min(rowsPerPage, activeUserConsumingAssets.length - page * rowsPerPage);
    let dateRangeTextOnCards = t("Monthly")
    let dateRangeTextOnDoughnut = matchingFrequency === enums.FrequencyTypes.DAILY ||  matchingFrequency === enums.FrequencyTypes.HOURLY ? t("Monthly") : t("Last 12 months")
    return (
    <div>
      {countryNavigationEnabled &&  this.renderCountryNavigation()}
      <div className={classes.root}>
        <Grid container spacing={24}>
          <AvoidedCO2Card user={user} classes={classes} t={t} loading={loading}
            infoButtonHandler={this.props.toggleCo2DetailsDialog_Dashboard}
            avoidedCO2GramsRange={frontEndDataForUser.totalAvoidedCO2GramsForRange}
            avoidedCO2GramsYTD={frontEndDataForUser.totalAvoidedCO2GramsYearToDate}
            dateRangeText={dateRangeTextOnCards}
          />

          <AvoidedCO2Dialog t={t} user={user}
            isOpen={this.props.dialogCo2DetailsOpen_Dashboard} 
            toggle={this.props.toggleCo2DetailsDialog_Dashboard}
            co2Equivalents={frontEndDataForUser.CO2Equivalents}
          />

          <ConvertedAvoidedCO2Card user={user} classes={classes} t={t} loading={loading}
            infoButtonHandler={this.props.toggleCo2DetailsDialog_Dashboard}
            dateRangeText={dateRangeTextOnCards}
            avoidedCO2GramsYTD={frontEndDataForUser.totalAvoidedCO2GramsYearToDate}
            energyMatchedInWhYTD={frontEndDataForUser.totalEnergyMatchedInWhYearToDate}
            co2Equivalents={frontEndDataForUser.CO2Equivalents}
          />

          <GreenElectricityCardNew classes={classes} t={t} loading={loading}
            energyInWhForRange={frontEndDataForUser.totalEnergyMatchedInWhForRange}
            energyInWhYTD={frontEndDataForUser.totalEnergyMatchedInWhYearToDate}
            dateRangeText={dateRangeTextOnCards}
          />

          <AverageDistanceCard user={user} classes={classes} t={t} loading={loading}
            averageDistanceInMetersForRange={frontEndDataForUser.averageDistanceForRangeInMeters}
            averageDistanceInMetersYTD={frontEndDataForUser.averageDistanceYTDInMeters}
            dateRangeText={dateRangeTextOnCards}
          />
            
          <DoughnutCard 
            classes={classes} 
            t={t} 
            key='longPeriodDashboardDoughnutCard' 
            chartName='longPeriodDashboardDoughnutCard' 
            loading={loading}
            title={ `${t("Energy sources ratio")} (${dateRangeTextOnDoughnut})`}
            subTitle={t("The sources of your asset's energy consumption")}
            centralPercentage={this.props.producingAssetPercentageForRange.percentageOfTotalMatchedEnergy * 100}
            percentageWithLabelArray={this.props.doughnutDataForRange}
            />

          <Grid item xs={12} sm={6}>
            <Paper className={classes.card} style={{ minHeight: 469}}>
              <DashboardToolbar numSelected={selected.length} loading={loading} t={t} i18n={i18n}/>
              <div className={classes.tableWrapper}>
                <Table className={classes.table} style={{minWidth: 0}}>
                  <DashboardHead
                    numSelected={selected.length}
                    order={order}
                    orderBy={orderBy}
                    onSelectAllClick={this.handleSelectAllClick}
                    onRequestSort={this.handleRequestSort}
                    rowCount={activeUserConsumingAssets.length}
                    t={t}
                    i18n={i18n}
                  />
                  <TableBody>
                    {activeUserConsumingAssets.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map(n => {
                      
                      const isSelected = this.isSelected(n.id);

                      return (
                        <TableRow
                          hover
                          onClick={event => this.handleClick(event, n.id)}
                          role="checkbox"
                          aria-checked={isSelected}
                          tabIndex={-1}
                          key={n.id}
                          selected={isSelected}
                          style={{
                            cursor: "pointer"
                          }}
                        >

                          <TableCell>{n.name ? n.name : n.city}</TableCell>
                          <TableCell>{n.countryLink && n.countryLink.name ? n.countryLink.name: ''}</TableCell>
                        </TableRow>
                      );
                    })}
                    {emptyRows > 0 && (
                      <TableRow style={{ height: 49 * emptyRows }}>
                        <TableCell colSpan={6} />
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </div>
              <TablePagination
                component="div"
                count={activeUserConsumingAssets.length}
                labelDisplayedRows={({ from, to, count }) => from+"-"+to +t(" of ")+ count}
                labelRowsPerPage={t("RowsPerPage")}
                rowsPerPage={rowsPerPage}
                rowsPerPageOptions={[5]}
                page={page}
                backIconButtonProps={{
                  'aria-label': 'Previous Page',
                }}
                nextIconButtonProps={{
                  'aria-label': 'Next Page',
                }}
                onChangePage={this.handleChangePage}
              />
            </Paper>
          </Grid>
        </Grid>

      </div>
      </div>
    );
  }
}

Dashboard.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = ({ dashboardReducer, assetsConsumingReducer, router, loginReducer }) => {
  const {
    order,
    orderBy,
    selected,
    page,
    yearToDateAssetsData,
    userTotalYearToDateAvoidedCO2
  } = assetsConsumingReducer;
  
  const {
    activeUserConsumingAssets,
    producingAssetPercentageForRange,
    producingAssetPercentageYTD,
    producingAssetPercentageLastMatchedDay,
    doughnutDataForRange,
    doughnutDataYTD,
    doughnutDataLastMatchedDay,
    frontEndDataForUser,
    lastMatchedDay,
    loading,
    matchingFrequency,
    dialogCo2DetailsOpen_Dashboard,
    countryNavigationEnabled,
    uniqueCountriesArray,
    countriesMenuOpen,
    globalViewButtonPressed,
    countryViewButtonPressed,
    lastDashboardLoad
  } = dashboardReducer;
  const { location } = router;
  const { isAuthenticated, username, user } = loginReducer;
  return {
    activeUserConsumingAssets,
    loading,
    order,
    orderBy,
    selected,
    page,
    location,
    isAuthenticated,
    username,
    user,
    dialogCo2DetailsOpen_Dashboard,
    yearToDateAssetsData,
    userTotalYearToDateAvoidedCO2,
    producingAssetPercentageForRange,
    producingAssetPercentageYTD,
    producingAssetPercentageLastMatchedDay,
    doughnutDataForRange,
    doughnutDataYTD,
    doughnutDataLastMatchedDay,
    frontEndDataForUser,
    lastMatchedDay,
    matchingFrequency,
    countryNavigationEnabled,
    uniqueCountriesArray,
    countriesMenuOpen,
    globalViewButtonPressed,
    countryViewButtonPressed,
    lastDashboardLoad
  };
};

const mapDispatchToProps = {
  startLoadingDashboard,
  dashboardStartNew,
  dashboardStart,
  stopLoadingDashboard,
  sortAssetsConsuming,
  changePage,
  changeRowsPerPage,
  getUsername,
  toggleCo2DetailsDialog_Dashboard,
  getUserTotalYearToDateAvoidedCO2,
  getCountriesRelatedToUserConsumingSites,
  setCountriesMenuState,
  globalViewButtonClicked,
  countryViewButtonClicked
}

Dashboard = withStyles(styles, {name: 'Dashboard'})(Dashboard);
Dashboard = translate("translations")(Dashboard);

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Dashboard))



// WEBPACK FOOTER //
// ./src/components/Dashboard.js